import { useLocalization } from 'src/utils/useLocalization';
import { useNavigate } from 'react-router-dom';

import './styles.scss';

const LockedUser = () => {
    const { labelTitle, labelText } = useLocalization();
    const navigation = useNavigate();

    const homePage = () => {
        navigation('/login');
    };

    return (
        <div className={'lockedaccount-form'}>
            <div className={'header u-mb-xlarge u-mt-xlarge'}>
                <h4>{labelTitle.LABEL_TITLE_LOCKED_ACCOUNT}</h4>
            </div>
            <div className={'info-section'}>
                <p>{labelText.LABEL_TEXT_ACCOUNT_LOCKED}</p>
                <p className={'highligthed'}>
                    {labelText.LABEL_TEXT_ACCOUNT_CONTACT}
                </p>
                <p>{labelText.LABEL_TEXT_OR}</p>
                <div className={'highligthed u-pb-xxsmall'}>
                    {labelText.LABEL_TEXT_ACCOUNT_BRAND}
                </div>
                <div className={'phone-number u-pb-xxsmall'}>
                    {labelText.LABEL_TEXT_ACCOUNT_PHONE}
                </div>
                <div>{labelText.LABEL_TEXT_ACCOUNT_HOURS}</div>
                <div>{labelText.LABEL_TEXT_ACCOUNT_WEEKEND_HOURS}</div>
            </div>
            <div className={'link-section'}>
                <a onClick={homePage}>{labelText.LABEL_TEXT_ACCOUNT_LINK}</a>
            </div>
        </div>
    );
};

export default LockedUser;
